<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M32 56a24 24 0 01-14-43.48V17a1.5 1.5 0 003 0V9.5a2 2 0 00-2-2h-7.5a1.5 1.5 0 000 3h4.18A27 27 0 0032 59a1.5 1.5 0 000-3zM52.5 53.5h-4.18A27 27 0 0032 5a1.5 1.5 0 000 3 24 24 0 0114 43.48V47a1.5 1.5 0 00-3 0v7.5a2 2 0 002 2h7.5a1.5 1.5 0 000-3z"/><path d="M33.5 34.3v-6.8h-3v6.8a4 4 0 103 0z"/><path d="M38 31.3V22a6 6 0 00-12 0v9.3a9 9 0 004.21 15.53A9.75 9.75 0 0032 47a9 9 0 006-15.7zm-2.19 11.33a6 6 0 11-7.41-9.42l.6-.45V22a3 3 0 016 0v10.76l.6.45a6 6 0 01.21 9.42z"/></svg>